export const SHOW_TOAST = "SHOW_TOAST";
export const HIDE_TOAST = "HIDE_TOAST";

export const showToast = payload => (dispatch, getStore) => {
  const { isActive } = getStore().toast;
  /* TODO: This is a quick hack for "toggling" toast */
  if (isActive) {
    dispatch({ type: HIDE_TOAST });
    setTimeout(() => {
      dispatch({ type: SHOW_TOAST, id: Date.now(), payload: { ...payload, message: payload.message } });
    }, 0);
  } else {
    dispatch({ type: SHOW_TOAST, id: Date.now(), payload: { ...payload, message: payload.message } });
  }
  setTimeout(() => dispatch({ type: HIDE_TOAST }), 5000);
};

export const hideToast = () => ({
  type: HIDE_TOAST,
});



// WEBPACK FOOTER //
// ./actions/toastActions.js